export const SITE_URL = 'https://www.debutinfotech.com';
export const BLOGS_URL = 'https://blogs.debutinfotech.com';
export const CDN_URL = 'https://www.debutinfotech.com/_next/image';
export const CONTACT_EMAIL = 'info@debutinfotech.com';

// Google "preferred source" — surfaces Debut Infotech as the top knowledge panel
// result. Used in the Google CTA widget across any content page (blogs, case studies, etc.).
export const GOOGLE_SEARCH_URL = 'https://www.google.com/search?q=Debut+Infotech';
